// Add any shared JS helper functions here
export class AxiosHelpers {
  static tryClientSideRedirect(result) {
    const loc = result.headers["location"];

    if (loc) {
      window.location = result.headers["location"];
      return true;
    } else {
      return false;
    }
  }

}
export class FormHelpers {
  static setFieldVisibility(field, isVisible) {
    const cl = field.classList;

    if (isVisible) {
      cl.remove("hidden");
    } else {
      cl.add("hidden");
    }
  } // So that the hidden fields pass server side validation if they were invalid when hidden


  static setNumberRangeFieldToMinimum(fieldElement) {
    const numberInput = fieldElement.querySelector("input[type=number]");
    const rangeInput = fieldElement.querySelector("input[type=range]");
    rangeInput.value = numberInput.value = numberInput.min;
    HtmlHelpers.triggerEvent(numberInput, "blur");
  }

}
export class StringHelpers {
  static formatCurrency(amount) {
    return amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

}
export class HtmlHelpers {
  static getAttributeWithFallback(element, name, fallbackValue = null) {
    const v = element.getAttribute(name);

    if (v) {
      return v;
    } else {
      return fallbackValue;
    }
  }

  static getDataWithFallback(element, name, fallbackValue = null) {
    return HtmlHelpers.getAttributeWithFallback(element, "data-" + name, fallbackValue);
  }

  static getDataIntWithFallback(element, name, fallbackValue = null) {
    const x = HtmlHelpers.getDataWithFallback(element, name, fallbackValue);
    return parseInt(x);
  }

  static triggerEvent(element, name, bubbles = false, cancellable = true) {
    var event = document.createEvent("Event");
    event.initEvent(name, bubbles, cancellable);
    element.dispatchEvent(event);
  }

  static isHidden(element) {
    var style = window.getComputedStyle(element);
    return style.display === 'none';
  }

  static isMobileWidthOrLess() {
    return window.innerWidth < 821;
  }

  static scrollToTopOfElement(element, offsetY) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + offsetY;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  static getSelectedOption(select) {
    return select.querySelector('option[value="' + select.value + '"]');
  }

  static swapOutAreas(htmlFragment, areaSelectors) {
    for (let selector of areaSelectors) {
      let html = HtmlHelpers.fragmentQuerySelector(htmlFragment, selector);
      if (!html) return false;
      let els = document.querySelectorAll(selector);

      for (let el of els) {
        el.innerHTML = html;
      }
    }
  } //static swapAreasWithClassTransition(appendInstead = false, htmlFragment, areaSelectors, cssClass, duration) {
  //    const promise = new Promise((resolve, reject) => {
  //        for (let areaSelector of areaSelectors) {
  //            //document.querySelector(areaSelector).classList.add(cssClass);
  //        }
  //        setTimeout(() => {
  //            if (this.swapOutAreas(appendInstead, htmlFragment, areaSelectors)) {
  //                resolve();
  //            } else {
  //                reject();
  //            }
  //            for (let areaSelector of areaSelectors) {
  //                //document.querySelector(areaSelector).classList.remove(cssClass);
  //            }
  //        }, duration);
  //    });
  //    return promise;
  //}


  static fragmentQuerySelector(htmlFragment, targetSelector) {
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlFragment;
    const target = tempDiv.querySelector(targetSelector);
    let html = "";

    if (target) {
      html = target.innerHTML;
    }

    return html;
  }

}